<template>
  <Upload :serviceRoute="serviceRoute" />
</template>

<script>
import Upload from "./upload.vue";

export default {
  components: {
    Upload
  },
  props: {
    // Defaults to the drilling staging daily reports file-processing route;
    // overridable so the page can be reused for other drilling uploads.
    serviceRoute: {
      type: String,
      default: "Drilling/StagingDailyReports"
    }
  }
};
</script>
